import { useQuery } from '@tanstack/react-query';

import { staffApi } from '../api/staff';

export const useGetRoles = () => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: () => staffApi.getRoles(),
  });
};
